import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, useMemo, useState } from 'react';
import { AccordionPanelContext } from './AccordionPanelContext';
export const AccordionPanel = ({ children, open, flush }) => {
    const [isOpen, setIsOpen] = useState(open);
    const items = useMemo(() => Children.map(children, (child) => cloneElement(child)), [children]);
    return _jsx(AccordionPanelContext.Provider, { value: { flush, isOpen, setIsOpen }, children: items });
};
